// TODO - remove lint disable when editing this file
/* eslint-disable */
import HeadlineConverter from './HeadlineConverter'

export default class SubheadlineConverter extends HeadlineConverter {
  constructor() {
    super('subheadline', ['header-two'])
    this.keyMap = {}
  }
}
